import styles from './Strength.module.scss'
import { useRef } from 'react'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

interface Props {
  list: {
    title: string
    text: string | JSX.Element
  }[]
}

const Strength: React.FC<Props> = ({ list }) => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  return (
    <section
      className={`${styles.strength} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <h2 className={styles.sectionTitle}>特長・強み</h2>
      <div className={styles.inner}>
        <ul className={styles.strength__list}>
          {list.map((item, index) => (
            <li key={index} className={`${styles.strength__list__item} Strength_item0${index + 1}`}>
              <h4 className={styles.strength__list__item__title}>{item.title}</h4>
              <div className={styles.strength__list__item__text}>{item.text}</div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default Strength
